import Section from 'app/frontend/base/components/Section'
import { useGuild } from 'app/frontend/base/config/context/guild'
import HousingPage from 'app/frontend/base/pages/TeamDashboard/subpages/TeamHousing/HousingPage'

const GuildHousing = () => {
  const { guild } = useGuild()

  if (!guild) return null

  return (
    <Section title={`Housing | ${guild.name}`}>
      <HousingPage allowAddingCharacters={false} />
    </Section>
  )
}

export default GuildHousing
